var lists_default = {
  "fontElementMap": "_7zuAq",
  "orderedlist": "P49FA",
  "bulletedlist": "_3laU7",
  "listItem": "m8IH7"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
